// Get all anchor links on the page
const 	anchorLinks = document.querySelectorAll('a[href^="#"]');
	const 	scrollToTargetWithOffset = (targetElement, behavior = "smooth", offset = document.querySelector('#sticky-nav').offsetHeight) => {
				if (targetElement) {
					console.log(targetElement.offsetTop + ' - ' + offset);
					
					window.scrollTo({
						top: targetElement.offsetTop - offset,
						behavior: behavior
					});
				}
			};

// Add click event listener to each anchor link
anchorLinks.forEach(link => {
	link.addEventListener('click', (event) => {
		event.preventDefault(); // Prevent default anchor link behavior

		// Get the target element based on the href value
		const targetId = link.getAttribute('href').substring(1);
		const targetElement = document.getElementById(targetId);

		scrollToTargetWithOffset(targetElement);
	});
});

window.onload = () => {
	const urlHash = window.location.hash;

	if (urlHash) {
		const targetId = urlHash.substring(1);
		const targetElement = document.getElementById(targetId);
		
		scrollToTargetWithOffset(targetElement, 'instant');
	}
};